import React from 'react';
import { TableContainer } from '@odin-labs/components';
import { useJobsiteSchedules } from './jobsiteSchedulesProvider';
import { JobsiteScheduleShift } from './JobsiteScheduleShift';

export function JobsiteSchedule(): React.ReactElement {
  const { selectedSchedule } = useJobsiteSchedules();

  return (
    <TableContainer className="jobsite-workers-container">
      {selectedSchedule?.shifts.map((shift) => (
        <JobsiteScheduleShift
          key={`jobsite-schedule-shift-${shift.id}`}
          shift={shift}
        />
      ))}
    </TableContainer>
  );
}
